"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateArguments = exports.isValidTimestamp = exports.isValidPassword = exports.isNull = exports.isNotNull = exports.isEmail = exports.isEmpty = exports.isNumeric = exports.isValidPhoneNumber = void 0;
const HTTP_1 = require("../enums/HTTP");
const index_1 = require("../util/index");
const Error = require("http-errors");
/**
 * Function to check if a given value is a valid phone number.
 * @param {string} value
 * @returns Boolean
 */
function isValidPhoneNumber(phoneNumber) {
    var re = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;
    return re.test(phoneNumber);
}
exports.isValidPhoneNumber = isValidPhoneNumber;
/**
 * Function to check if a given value is a valid number.
 * @param {any} value
 * @returns Boolean
 */
function isNumeric(value) {
    return !isNaN(value);
}
exports.isNumeric = isNumeric;
/**
 * Function to check if a given array is null or empty.
 * @param {array} result
 * @returns Boolean
 */
function isEmpty(result) {
    return result == null || result.length == 0;
}
exports.isEmpty = isEmpty;
/**
 * Helper method to determine if a given string is in valid email format
 * @param {string} email
 * @returns true/false if email is valid or not
 */
function isEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}
exports.isEmail = isEmail;
function isNotNull(variable) {
    return variable !== null && variable !== undefined;
}
exports.isNotNull = isNotNull;
function isNull(variable) {
    return variable === null || variable === undefined;
}
exports.isNull = isNull;
/**
 * Function tell if a given string is a valid password.
 * We enforce 8 characters, 1 upper, 1 lower, 1 number and 1 special.
 * @param {string} password
 * @returns Boolean
 */
function isValidPassword(password) {
    if (index_1.isDevMode()) {
        return true;
    }
    if (password.length < 8) {
        return false;
    }
    var hasUpperCase = /[A-Z]/.test(password);
    var hasLowerCase = /[a-z]/.test(password);
    var hasNumbers = /\d/.test(password);
    var hasNonAlphas = /\W/.test(password);
    if (!(hasUpperCase && hasLowerCase && hasNumbers && hasNonAlphas)) {
        return false;
    }
    return true;
}
exports.isValidPassword = isValidPassword;
/**
 * Function to check if a string is a valid ISO timestamp.
 * @param {string} timestamp
 * @returns Boolean
 */
function isValidTimestamp(timestamp) {
    var re = /\d{4}-[0-1]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d[+-]\d{2}:\d{2}/;
    return re.test(timestamp);
}
exports.isValidTimestamp = isValidTimestamp;
/**
 * Function to validate that all required route parameters were passed in
 * @param args object of parameters
 */
function validateArguments(args) {
    return __awaiter(this, void 0, void 0, function* () {
        var missingArgs = [];
        for (var key in args) {
            if (isNull(args[key])) {
                missingArgs.push(key);
            }
        }
        if (missingArgs.length == 1) {
            throw Error(HTTP_1.HTTP.BAD_REQUEST, `Missing required named argument: ${missingArgs[0]}.`);
        }
        else if (missingArgs.length > 1) {
            throw Error(HTTP_1.HTTP.BAD_REQUEST, `Missing required named arguments: ${missingArgs.join(', ')}.`);
        }
    });
}
exports.validateArguments = validateArguments;
